import { FC } from "react";
import { Route, Switch } from 'react-router-dom';
import MessageReceive from '../pages/message/receive';
import MessageReceiveRead from '../pages/message/receive/read';
import MessageSend from '../pages/message/send';
import MessageSendRead from '../pages/message/send/read';
import MessageArchive from '../pages/message/archive';
import MessageArchiveRead from '../pages/message/archive/read';
import MessageWrite from '../pages/message/write';
import SmsSend from "../pages/message/sms-send";
import SmsWrite from "../pages/message/sms-write";

const MessageRouter: FC = () => {
  return (
    <Switch>
      <Route path='/message/receive' exact component={MessageReceive} />
      <Route path='/message/receive/:messageCode' exact component={MessageReceiveRead} />
      <Route path='/message/send' exact component={MessageSend} />
      <Route path='/message/send/:messageCode' exact component={MessageSendRead} />
      <Route path='/message/archive' exact component={MessageArchive} />
      <Route path='/message/archive/:messageCode' exact component={MessageArchiveRead} />
      <Route path='/message/write' exact component={MessageWrite} />
      <Route path='/message/sms-send' exact component={SmsSend} />
      <Route path='/message/sms-write' exact component={SmsWrite} />
    </Switch>
  )
}

export default MessageRouter;
